<template>
  <div class="applyFor">
    <ul>
      <li>累计销售额：{{applyForObj.totalSaleAmount/100}} 元</li>
      <li>累计奖金：{{applyForObj.rewardAmount/100}} 元</li>
      <li>待生效推广费：{{applyForObj.totalMarketFee/100}} 元</li>
      <li>可申请结算金额（含奖金）：<span class="yellow">{{applyForObj.settleable/100}}</span> 元</li>
      <li>已结算总金额：{{applyForObj.cleared/100}} 元</li>
    </ul>
    <div>线下结算金额：{{applyForObj.settleableOffLine/100}} 元</div>
    <div class="block">
      <div class="user-type-selection">
        <el-radio-group v-model="userType" @change="onUserTypeChange">
          <el-radio label="personal">个人</el-radio>
          <el-radio label="enterprise">企业</el-radio>
        </el-radio-group>
      </div>
      <div class="amount-input">
        <el-input style='width: 300px;' type="input" v-model="applyForNum" placeholder="请输入结算金额"></el-input>
        <el-button type="primary" @click='setmouey' :disabled="btn">申请结算</el-button>
        <el-button type="success" @click='showInvoiceDialog' v-if="needInvoice">上传发票</el-button>
        <span class="red" v-if="btn">提示：您有一笔结算款正在进行中，无法申请新的结算</span>
      </div>
    </div>
    <!-- <div class="test red">
      <p>个人佣金结算申请每人每月提交一次，请在每月20号之前提交结算申请，超过500元的需附上劳务费发票，资料齐全的情况下，我们会在每月25号左右进行支付，如有特殊情况，请及时沟通。</p>
      <p>请根据您的结算金额，按照以下信息为大救星开具增值税专用发票（税率6%）：</p>
      <p>发票内容：咨询费、推广费、服务费。</p>
      <p>开票信息</p>
      <p>公司名称：江泰救援服务有限公司</p>
      <p>税号：91120118MA05J5YJ07</p>
      <p>地址、电话：天津自贸试验区（中心商务区）迎宾大道旷世国际大厦1栋-1703E-18 010-68188889</p>
      <p>开户行及账号：招商银行北京丽泽商务区支行110921622710301</p>

      <p>收件地址：大救星业务部收，68188889，北京市门头沟区莲石湖西路98号院9号楼江泰保险大厦。</p>

      <p>* 无法开具专票的旅行社，在使用普票申请结算时由大救星代扣税费（6%），电子普票可通过“结算记录”自行上传提交。</p>
    </div> -->
   
    <div class="test">
      <p>请根据您的结算金额，按照以下信息为大救星开具增值税专用发票（税率6%）：</p>
      <p>发票内容：咨询费、推广费、服务费。</p>
      <p>开票信息</p>
      <p>公司名称：江泰救援服务有限公司</p>
      <p>税号：91120118MA05J5YJ07</p>
      <!-- <p>地址、电话：北京市门头沟区莲石湖西路98号院9栋2层201 010-68188889</p>
      <p>开户行及账号：招商银行北京丽泽商务区支行110921622710301</p>
      <p>收件地址：大救星业务部收，68188889，北京市门头沟区莲石湖西路98号院9号楼江泰保险大厦。</p> -->
      <p>个人佣金结算申请每人每月提交一次，请在每月20号之前提交结算申请，超过500元的需附上劳务费发票，资料齐全的情况下，我们会在每月25号左右进行支付，如有特殊情况，请及时沟通。</p>
      <p>* 无法开具专票的企业或个人，在使用普票申请结算时由大救星代扣税费（6%），电子发票可通过"结算记录"自行上传提交。</p>
    </div>
    
    <!-- 发票上传弹框 -->
    <el-dialog title="发票上传说明" :visible.sync="invoiceDialogVisible" width="800" center top="1vh">
      <invoiceUpload :settlementAmount="applyForNum" @uploadSuccess="onInvoiceUploadSuccess"></invoiceUpload>
    </el-dialog>
  </div>
</template>

<script>
  import {
    settleStat,
    settle
  } from '@/axios/api'
  import invoiceUpload from './invoiceUpload'

  export default {
    components: {
      invoiceUpload
    },
    data() {
      return {
        applyForNum: '',
        applyForObj: {},
        btn: false,
        userType: 'personal', // 用户类型：personal-个人，enterprise-企业
        invoiceDialogVisible: false, // 发票上传弹框显示状态
        hasUploadedInvoice: false, // 是否已上传发票
        invoiceType: '', // 发票类型：2-专票，3-普票
        invoice: '' // 发票文件URL
      }
    },
    computed: {
      /**
       * 判断是否需要上传发票
       * 企业：必须上传发票
       * 个人：300元以内可不上传，超过300元必须上传
       */
      needInvoice() {
        if (this.userType === 'enterprise') {
          return true; // 企业必须上传发票
        } else if (this.userType === 'personal') {
          return parseFloat(this.applyForNum) > 500; // 个人超过300元需要上传发票
        }
        return false;
      }
    },
    methods: {
      getDate() {
        settleStat()
          .then(res => {
            this.applyForObj = res.data.obj;
            this.applyForObj.settleableOffLine = this.applyForObj.settleableOffLine ? this.applyForObj.settleableOffLine : 0;
            if (res.data.obj2) {
              this.btn = true
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      setmouey() {
        if (this.applyForNum == '' || this.applyForNum == 0) return this.$message.warning('请输入申请金额')
        
        // 检查是否需要上传发票
        if (this.needInvoice && !this.hasUploadedInvoice) {
          if (this.userType === 'enterprise') {
            this.$message.warning('企业用户必须上传发票后才能提交申请')
          } else {
            this.$message.warning('个人用户超过500元需要上传发票后才能提交申请')
          }
          return;
        }
        
        // 准备提交数据
        const submitData = {
          amount: Math.trunc(this.applyForNum * 100)
        }
        
        // 如果需要上传发票且已上传，则添加发票参数
        if (this.needInvoice && this.hasUploadedInvoice) {
          submitData.invoiceType = this.invoiceType
          submitData.invoice = this.invoice
        }
        
        // 提交结算申请
        settle(submitData)
        .then(res => {
          if (res.data.code == 0) {
            this.$message({
              type: 'success',
              message: '申请成功！'
            })
            this.applyForNum = '';
            this.btn = true
            this.hasUploadedInvoice = false; // 重置发票上传状态
          } else if (res.data.code == 105019) {
            this.$message.warning('尚有订单未激活，请根据"可结算金额"申请')
          } else if (res.data.code == 105022) {
            this.$message.warning('申请结算前， 请先设置机构银行账号')
          } else if (res.data.code == 105038) {
            this.$message.warning('每月仅允许提现一次');
          } else {
            this.$message.warning(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
      },
      
      /**
       * 用户类型改变时的处理
       */
      onUserTypeChange() {
        this.hasUploadedInvoice = false; // 重置发票上传状态
        this.invoiceType = ''; // 重置发票类型
        this.invoice = ''; // 重置发票文件URL
      },
      
      /**
       * 显示发票上传弹框
       */
      showInvoiceDialog() {
        this.invoiceDialogVisible = true;
      },
      
      /**
       * 发票上传成功回调
       * @param {Object} invoiceData - 发票数据，包含invoiceType和invoice
       */
      onInvoiceUploadSuccess(invoiceData) {
        this.hasUploadedInvoice = true;
        this.invoiceType = invoiceData.invoiceType;
        this.invoice = invoiceData.invoice;
        this.invoiceDialogVisible = false;
        this.$message.success('发票上传成功！');
      }
    },
    mounted() {
      this.getDate()
    }
  }
</script>

<style scoped="scoped">
  .applyFor ul {
    overflow: hidden;
  }

  .applyFor ul li {
    float: left;
    margin-right: 20px;
    line-height: 35px;
  }

  .block {
    margin-top: 20px;
  }

  .test {
    margin-top: 20px;
    font-size: 14px;
  }

  .test p {
    line-height: 1.5;
  }

  .user-type-selection {
    margin-bottom: 15px;
  }

  .amount-input {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .amount-input .el-button {
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/financial/settlement/applyFor.vue